export enum MaterialTypes {
    UNIT,
    METER,
    METER_SQUARED,
}
